"use client";

import { Box, Stack, StackProps } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { CSSProperties, FC } from "react";
import SalifyComponent from "../salify-component/default";
import { SalifyLinkV2 } from "../ui/link/link";

interface SalifyBannerWrapperProps {
  link: any;
  img: {
    src: any;
    cssProps?: CSSProperties;
  };
  content: {
    position?: "top" | "left" | "right" | "bottom";
    cssProps: StackProps;
    components: any[];
  };
  cssProps?: StackProps;
  overlayBackground?: CSSProperties;
}

const SalifyBannerWrapperCutoutImg: FC<SalifyBannerWrapperProps> = (props) => {
  return (
    <SalifyLinkV2 href={props.link}>
      <Stack
        direction={
          props.content?.position === "left"
            ? "row"
            : props.content?.position === "right"
              ? "row-reverse"
              : props.content?.position === "bottom"
                ? "column-reverse"
                : "column"
        }
        {...props.cssProps}
        sx={{
          ":hover img": {
            transform: "scale(1.05)",
          },
          ...(props.overlayBackground && {
            "::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              opacity: 0.7,
              ...props.overlayBackground,
            },
          }),
          ...props.cssProps?.sx,
        }}
      >
        {props.content?.components && !!props.content?.components?.length && (
          <Stack
            zIndex={
              props.overlayBackground?.zIndex ? Number(props.overlayBackground.zIndex) + 1 : 1
            }
            flex={1}
            {...props.content.cssProps}
          >
            <SalifyComponent components={props.content.components} />
          </Stack>
        )}

        <Box
          component="img"
          src={props.img?.src}
          alt={props.img?.src}
          loading="lazy"
          width="100%"
          height="auto"
          maxHeight="inherit"
          sx={{
            objectFit: "cover",
            transition: "transform 0.3s ease-in-out",
            ...props.img?.cssProps,
          }}
        />
      </Stack>
    </SalifyLinkV2>
  );
};

SalifyBannerWrapperCutoutImg.displayName = "SalifyBannerWrapper";

export default SalifyBannerWrapperCutoutImg;
